/* components/ScrollButton.js */
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin)

export default class ScrollButtons {
  constructor(els){
    this.buttons = null

    this.initEvents()
  }
  initEvents() {
    this.buttons = document.querySelectorAll('[data-scroll-button]')

    if ( this.buttons.length ) {
      this.buttons.forEach(button => {
        button.addEventListener("click", this.handleClick);
      })
    }

  } 
  removeEvents() {
    this.buttons.forEach(button => {
      button.removeEventListener("click", this.handleClick);
    })
  }
  handleClick() {

    let target = event.target.getAttribute('data-scroll-button')
    let offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--headerHeight'))

    gsap
    .to(window, 1, {
      scrollTo: {
        y: target,
        offsetY: offset,
        // autoKill: true,
        ease: "power2.inOut"
      }
    })

  }
  destroy() {
    this.removeEvents();
  }

}
